// extracted by mini-css-extract-plugin
var _1 = "checkbox__sVMAl";
var _2 = "checkbox-element__ZxDXv";
var _3 = "checkbox-label__meelz";
var _4 = "is-active__n_ROG";
var _5 = "is-disabled__yTFoZ";
var _6 = "is-switch__cr4VN";
var _7 = "wrapper__ylfLm";
export { _1 as "checkbox", _2 as "checkbox-element", _3 as "checkbox-label", _4 as "is-active", _5 as "is-disabled", _6 as "is-switch", _7 as "wrapper" }
